import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {Box, Center, Heading, Text} from '@chakra-ui/react';
import {SalesforceErrorsDownloader} from './SalesforceErrorsDownloader';

export const SalesforceErrors = () => {
  const [searchParams] = useSearchParams();

  const taskId = searchParams.get('taskId');

  if (!taskId) {
    return (
      <Box p={8}>
        <Heading size="md" mb={4}>
          Missing Parameters
        </Heading>
        <Text>
          This page requires a taskId query parameter to download Salesforce
          errors.
        </Text>
      </Box>
    );
  }

  return (
    <Center p={8}>
      <SalesforceErrorsDownloader rawTaskId={taskId} />
    </Center>
  );
};
